import client from './client';

export const listJobOpenings = () => client.get('/api/job-openings');

export const createJobOpening = (data) => client.post('/api/job-openings', data);

export const updateJobOpening = (id, data) => client.patch(`/api/job-openings/${id}`, data);

export const deleteJobOpening = (id) => client.delete(`/api/job-openings/${id}`);
